import { Link, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { AppBar, Container } from "@mui/material";
import { useAuthContext } from "hooks/useAuth";
import { useContext } from "react";
import { AuthContext } from "contexts/AuthContext";
import axios from "axios";

const headerHeight = "55px"

export default function Header() {

  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { setUser } = useContext(AuthContext);

  const logout = () => {
    axios.post("/api/user/logout")
    .then(() => {
      setUser(null);
    })
    .catch(() => {
      alert("로그아웃에 실패하였습니다.");
    })
  };

  return (
    <>
      <AppBar>
        <Inner>
          <Logo to="/">
            DEBT NOTE
          </Logo>

          {user ? 
            <div onClick={logout}>{user.userName}</div>
            :
            <LoginButton to="/login">
              Login
            </LoginButton>
          }
        </Inner>
      </AppBar>
      <div style={{height: headerHeight}}/>
    </>
  );
}

// Appbar inner
const Inner = styled(Container)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  height: headerHeight
});

// 로고
const Logo = styled(Link)({
  fontFamily: "NanumSquareExtraBold",
  textDecoration: "none",
  color: "#fff"
});

// 로그인 버튼
const LoginButton = styled(Link)({
  fontFamily: "NanumSquareBold",
  textDecoration: "none",
  color: "#fff"
});